/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Recover_SubtitleInputs */



/**
* | output |
* | --- |
* | "Enter your email to receive a login link" |
*
* @param {Auth_Recover_SubtitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_recover_subtitle = /** @type {((inputs?: Auth_Recover_SubtitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Recover_SubtitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Gib deine E-Mail ein, um einen Anmeldelink zu erhalten")
	return /** @type {LocalizedString} */ ("Enter your email to receive a login link")
});